import * as ApiCaller from '../libs/httpRequests';

const prefix = 'KS';

export function GetListQuestions(mabn)  {
    if (mabn === undefined || mabn === null) mabn = "";
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/GetListQuestions?val=${mabn}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function CreateSurvey(survey){
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/CreateSurvey`, survey).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
}